/*
  CEBE theme — assets/cebe.js, part 2 of 4: cart queue, drawer start and cart page.
  Load all parts in this order, each with defer: cebe-part-1.js, cebe-part-2.js, cebe-part-3.js, cebe-part-4.js.
  Made by website/review/sammel-2026-10-03/werkzeuge/zusammenfuehren.py from assets/cebe.js (MD5 46a65575485db7a4e2796e006f51aee3);
  every Shopify upload file must stay below 26 000 bytes. Between the markers stands the original code; the only change:
  a name that one part changes and another reads, or that comes from a later part, reads cebeShared.<name> (one private
  object, window.__cebeParts.main). See website/review/sammel-2026-10-03/TEILUNG.md.
*/
(function () {
  'use strict';

  var cebeShared = (window.__cebeParts = window.__cebeParts || {}).main || (window.__cebeParts.main = {});
  if (cebeShared.done !== 1) return; // part 1 did not finish (error or early return): stop, as the single file would
  var config = cebeShared.config;
  var $ = cebeShared.$;
  var $$ = cebeShared.$$;
  var announce = cebeShared.announce;
  var errorText = cebeShared.errorText;
  var CART_WAIT = cebeShared.CART_WAIT;
  var limitedJson = cebeShared.limitedJson;
  var SECTION = cebeShared.SECTION;
  var parse = cebeShared.parse;
  var fill = cebeShared.fill;
  var currentCount = cebeShared.currentCount;
  var showError = cebeShared.showError;
  var lineByKey = cebeShared.lineByKey;
  var swapParts = cebeShared.swapParts;
  var focusDescriptor = cebeShared.focusDescriptor;
  var restoreFocus = cebeShared.restoreFocus;
  var updateEdges = cebeShared.updateEdges;
  var updateFit = cebeShared.updateFit;
  var updateExpress = cebeShared.updateExpress;
  var renderDrawer = cebeShared.renderDrawer;
  var refreshDrawer = cebeShared.refreshDrawer;
  var openDrawer = cebeShared.openDrawer;
  var finishClose = cebeShared.finishClose;
  var closeDrawer = cebeShared.closeDrawer;

  /* ---- assets/cebe.js, lines 390–770 ---- */

  /* ---------- One queue for every cart surface ----------
     The number changes at once; prices always come from the server. No tap is dropped: the newest wanted quantity
     per line key waits here, one request runs at a time ("Add to cart" too), and only the newest answer is drawn. */
  var wanted = {};
  var order = [];
  var activeSurface = null;
  var running = false;
  var stepTimer = 0;
  var waiting = [];
  var batch = newBatch();
  cebeShared.issued = 0; // every request that may draw gets the next number; only the newest one draws
  var refreshing = false; // the newest finished batch still waits for its reload from the server
  var finishing = 0; // every finish gets the next number; only the newest one speaks and frees the waiting callers
  var reloadFailure = ''; // what that waiting finish has to say, if a newer batch takes over before the reload answers
  var draft = null;
  var businessPending = false;
  var renderPending = false;
  var renderSerial = 0;
  var renderHold = false;
  cebeShared.unsure = {}; // line key → the quantity a change asked for whose outcome no answer has told (see holds)
  cebeShared.unsureSerial = 0; // changes that became unsure
  cebeShared.pageSurface = null; // the cart page, if this is it

  function newBatch() {
    return { removed: {}, changed: {}, asked: {}, titles: {}, failure: '', answer: null };
  }

  function cartIdle() {
    return !running && !stepTimer && order.length === 0 && !refreshing;
  }

  function current(ticket) {
    return ticket === cebeShared.issued && order.length === 0;
  }

  function clearQueue() {
    window.clearTimeout(stepTimer);
    stepTimer = 0;
    wanted = {};
    order = [];
    batch = newBatch();
  }

  // One by one, and only while the queue stays idle: a callback may start work again ("Add to cart").
  function settle(ok) {
    while (waiting.length && cartIdle()) waiting.shift()(ok);
  }

  function whenIdle(callback) {
    if (cartIdle()) return callback(true);
    waiting.push(callback);
    if (stepTimer) flush(); // collected taps go now
  }

  function batchMessage(surface, done) {
    var strings = config.strings;
    var removed = Object.keys(done.removed);
    if (currentCount() === 0 && strings.empty) return strings.empty;
    if (removed.length && !Object.keys(done.changed).length && strings.removedItem) {
      return fill(strings.removedItem, '[product]', done.removed[removed[removed.length - 1]]);
    }
    var subtotal = $('[data-cebe-part="summary"] [data-cebe-subtotal]', surface.scope);
    if (subtotal && strings.updatedTotal) return fill(strings.updatedTotal, '[total]', subtotal.textContent.trim());
    return strings.updated;
  }

  function cartScopes() {
    return [cebeShared.pageSurface && cebeShared.pageSurface.scope, cebeShared.drawer].filter(function (scope) {
      return Boolean(scope);
    });
  }

  function rollbackQuantity(key, rejected) {
    cartScopes().forEach(function (scope) {
      var line = lineByKey(scope, key);
      var input = line && $('[data-cebe-qty] input', line);
      if (!input) return;
      if (document.activeElement !== input || input.value === String(rejected)) input.value = input.defaultValue;
      line.dataset.cebeQuantity = input.defaultValue;
    });
  }

  function adoptDefaults(data) {
    if (!data || !Array.isArray(data.items)) return;
    var values = Object.create(null);
    data.items.forEach(function (item) { values[item.key] = String(item.quantity); });
    cartScopes().forEach(function (scope) {
      $$('[data-cebe-key]', scope).forEach(function (line) {
        var input = $('[data-cebe-qty] input', line);
        if (!input) return;
        var value = values[line.dataset.cebeKey] || '0';
        if (input.defaultValue !== value && $('[data-cebe-b2b-cart-state]', scope)) businessPending = true;
        var edited = input.value;
        input.defaultValue = value;
        input.value = edited;
      });
    });
  }

  function registerRenderHold() {
    if (renderHold || !config.cart || !config.cart.hold) return;
    renderHold = true;
    config.cart.hold({
      state: function () { return renderPending ? 'unclear' : ''; },
      serial: function () { return renderSerial; },
      accept: function () {}, // sections are required
      check: function () { renderPending = false; businessPending = false; }
    });
  }

  function recoverCart(seq) {
    var ticket = cebeShared.issued;
    function newest() {
      return seq === finishing && current(ticket) && !running && !stepTimer;
    }
    if (!newest()) return Promise.resolve(false);
    return limitedJson((config.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }, CART_WAIT)
      .then(function (cart) {
        if (!newest() || !cart || !Array.isArray(cart.items) || typeof cart.item_count !== 'number') return false;
        var items = Object.create(null);
        var count = 0;
        var valid = cart.items.every(function (item) {
          if (!item || typeof item.key !== 'string' || typeof item.quantity !== 'number' || item.quantity < 0 || item.quantity % 1) return false;
          items[item.key] = item;
          count += item.quantity;
          return true;
        });
        if (!valid || count !== cart.item_count) return false;
        var complete = !businessPending;
        var english = (document.documentElement.lang || '').split('-')[0] === 'en';
        var englishEUR = cart.currency === 'EUR' && english;
        function price(node, amount, each) {
          if (!node) return;
          var match = node.textContent.match(each ? /^\s*(-?€\d+\.\d{2})([\s\S]*)$/ : /^\s*(-?€\d+\.\d{2})\s*$/);
          if (!englishEUR || !match || typeof amount !== 'number' || !isFinite(amount) || amount % 1) {
            complete = false;
            return;
          }
          node.textContent = (amount < 0 ? '-' : '') + '€' + (Math.abs(amount) / 100).toFixed(2) + (each ? match[2] : '');
        }
        function countText(text) {
          if (!english) return null;
          var match = text.match(/^(\s*(?:[^,\n]+,\s*)?)(\d+)(\s+item)(s?)(\s*)$/);
          return match ? match[1] + String(count) + match[3] + (count === 1 ? '' : 's') + match[5] : null;
        }
        cartScopes().forEach(function (scope) {
          var keys = Object.create(null);
          var changed = false;
          $$('[data-cebe-key]', scope).forEach(function (line) {
            var key = line.dataset.cebeKey;
            var item = items[key];
            var quantity = item ? item.quantity : 0;
            var input = $('[data-cebe-qty] input', line);
            keys[key] = true;
            if (!item || !input) complete = false;
            if (input) {
              changed = changed || Number(input.defaultValue) !== quantity;
              input.defaultValue = String(quantity);
              input.value = String(quantity);
            }
            line.dataset.cebeQuantity = String(quantity);
            price($('.cebe-line__price', line), item ? item.final_line_price : 0, false);
            price($('.cebe-line__each', line), item ? item.final_price : 0, true);
          });
          if (Object.keys(keys).length !== cart.items.length || cart.items.some(function (item) { return !keys[item.key]; })) complete = false;
          var business = $('[data-cebe-b2b-cart-state]', scope);
          if (changed && business) complete = false; // cart JSON has no tags: keep the server-rendered classification.
          price($('[data-cebe-subtotal]', scope), cart.total_price, false);
        });
        $$('[data-cebe-part="count"]').forEach(function (node) {
          var replaced = false;
          Array.prototype.forEach.call(node.childNodes, function (child) {
            if (child.nodeType !== 3 || !child.textContent.trim()) return;
            var next = countText(child.textContent);
            if (next === null) complete = false;
            else { child.textContent = next; replaced = true; }
          });
          if (!replaced && count) complete = false;
        });
        $$('[data-cebe-cart-count-source]').forEach(function (source) {
          var old = parseInt(source.textContent, 10) || 0;
          var label = countText(source.dataset.label || '');
          source.textContent = String(count);
          if (label !== null) source.dataset.label = label;
          else if (old !== count) complete = false;
        });
        $$('[data-cebe-cart-count]').forEach(function (node) { node.textContent = String(count); });
        var source = $('[data-cebe-cart-count-source]');
        var link = $('[data-cebe-cart-open]');
        if (source && link && countText(source.dataset.label || '') !== null) link.setAttribute('aria-label', source.dataset.label);
        updateExpress(count);
        updateFit();
        updateEdges();
        return complete;
      })
      .catch(function () { return false; });
  }

  function requestQuantity(surface, line, quantity, now) {
    var key = line && line.dataset.cebeKey;
    if (!key) return;
    if (draft && draft.scope === surface.scope && draft.key === key) draft = null;
    quantity = Math.max(0, quantity || 0);
    var input = $('[data-cebe-qty] input', line);
    if (input) input.value = String(quantity);
    line.dataset.cebeQuantity = String(quantity);
    line.setAttribute('aria-busy', 'true');
    var summary = $('[data-cebe-part="summary"]', surface.scope);
    if (summary) summary.setAttribute('aria-busy', 'true');
    surface.error('');
    cebeShared.decided = -1; // the cart changes: an offer to continue with the cart as shown no longer stands
    activeSurface = surface;
    if (!Object.prototype.hasOwnProperty.call(wanted, key)) order.push(key);
    wanted[key] = quantity;
    var title = $('.cebe-line__title', line);
    batch.titles[key] = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
    if (quantity === 0) {
      batch.removed[key] = batch.titles[key];
      delete batch.changed[key];
    } else {
      batch.changed[key] = true;
      delete batch.removed[key];
    }
    window.clearTimeout(stepTimer);
    stepTimer = 0;
    if (now) flush();
    else stepTimer = window.setTimeout(flush, 300); // taps on +/- are collected
  }

  function flush() {
    window.clearTimeout(stepTimer);
    stepTimer = 0;
    if (running) return;
    var surface = activeSurface;
    var key = order.shift();
    if (key === undefined || !surface) return settle(true);
    var quantity = wanted[key];
    delete wanted[key];
    batch.asked[key] = quantity;
    running = true;
    var ticket = ++cebeShared.issued;
    cebeShared.holds.forEach(function (hold) {
      if (hold.changing) hold.changing(key); // assets/cebe-product.js: the cart's number of this coffee is in motion
    });
    limitedJson(
      config.routes.cartChange,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        // id = the line key: it survives quantity changes, positions do not survive a removal.
        body: JSON.stringify({ id: key, quantity: quantity, sections: surface.sections().join(','), sections_url: window.location.pathname })
      },
      CART_WAIT
    )
      .then(
        function (data) {
          adoptDefaults(data);
          delete cebeShared.unsure[key]; // the newest quantity for this line is what the server holds
          cebeShared.holds.forEach(function (hold) {
            if (hold.changed) hold.changed(key, data); // the cart as the server holds it now
          });
          batch.answer = { sections: data.sections || {}, ticket: ticket };
          cebeShared.syncHeld();
        },
        function (error) {
          if (error && error.rejected) {
            // A newer edit of this same line waits in wanted: keep its displayed value and send it next.
            // Only a rejected last edit rolls back; changes of the other lines continue as before.
            if (!Object.prototype.hasOwnProperty.call(wanted, key)) {
              rollbackQuantity(key, quantity);
              order = order.filter(function (other) {
                return other !== key;
              });
              delete batch.changed[key];
              delete batch.removed[key];
              delete batch.asked[key];
            }
          } else {
            // No connection, a server fault or no answer in time: nothing more is sent. The server may still carry this
            // one out, so "Check out" waits until the cart shows this quantity or the customer decides (holds).
            cebeShared.unsure[key] = quantity;
            cebeShared.unsureSerial += 1;
            clearQueue();
            cebeShared.syncHeld();
          }
          batch.failure = errorText(error);
        }
      )
      .then(function () {
        running = false;
        if (order.length) flush(); // newer taps are waiting: no in-between drawing
        else finish(surface);
      });
  }

  // A batch is done: draw the newest answer (or reload), say once what happened, then free the waiting callers.
  // While a reload runs the cart is not idle ("Check out" and "Add to cart" wait). A newer batch that finishes first
  // takes over: it also says what the older one had to say, and the older one then stays silent.
  function finish(surface) {
    var done = batch;
    batch = newBatch();
    var seq = ++finishing;
    if (refreshing) done.failure = done.failure || reloadFailure;
    refreshing = false;
    var answer = done.answer;
    var drawn = answer && current(answer.ticket) && surface.render(answer.sections, { keepScroll: true });
    if (!drawn) {
      refreshing = true;
      reloadFailure = done.failure;
    }
    (drawn ? Promise.resolve(true) : surface.refresh()).catch(function () { return false; }).then(function (ok) {
      return ok || seq !== finishing ? ok : recoverCart(seq);
    }).then(function (ok) {
      if (seq !== finishing) return; // a newer finish rules: no error, no announcement, no settle from here
      refreshing = false;
      if (!cartIdle()) {
        batch.failure = batch.failure || done.failure; // newer taps draw and speak, this rejection included
        return;
      }
      renderPending = !ok;
      if (ok) businessPending = false;
      else renderSerial += 1;
      cebeShared.syncHeld();
      var focused = document.activeElement;
      var focusedLine = focused && focused.closest && focused.closest('[data-cebe-key]');
      if (draft && focusedLine && focusedLine.dataset.cebeKey === draft.key && draft.scope.contains(focused) && focused.matches('[data-cebe-qty] input')) focused.value = draft.value;
      $$('[aria-busy]', surface.scope).forEach(function (node) {
        node.removeAttribute('aria-busy');
      });
      var notes = done.failure ? [done.failure] : [];
      if (!ok && !done.failure) notes.push(config.strings.error);
      // Shopify may cap a quantity at the stock and still answer 200.
      Object.keys(done.asked).forEach(function (key) {
        var line = lineByKey(surface.scope, key);
        var got = line ? parseInt(line.dataset.cebeQuantity, 10) || 0 : done.asked[key];
        if (got < done.asked[key] && config.strings.limited) {
          notes.push(fill(fill(config.strings.limited, '[product]', done.titles[key]), '[quantity]', String(got)));
        }
      });
      surface.error(notes.join(' ')); // shown here, spoken once below: the line itself is not a live region
      var changed = ok && (Object.keys(done.changed).length || Object.keys(done.removed).length);
      announce(notes.concat(changed ? [batchMessage(surface, done)] : []).join(' '));
      settle(notes.length === 0);
    });
  }

  // "Add to cart" runs in the same queue: it waits for open changes, and changes wait for it.
  // task(draw) returns a promise; draw(html, opts) draws the drawer unless a newer answer exists. The promise resolves
  // with false (or rejects) when the task did not succeed or its outcome is unknown: the waiting callers learn it
  // (settle(false), so a waiting "Check out" does not start).
  function exclusive(task) {
    whenIdle(function () {
      running = true;
      var ticket = ++cebeShared.issued;
      function release(result) {
        running = false;
        if (order.length) flush();
        else settle(result !== false);
      }
      task(function (html, opts) {
        if (current(ticket) && !renderDrawer(html, opts)) refreshDrawer();
      }).then(release, function () {
        release(false);
      });
    });
  }

  function bindLines(surface) {
    var scope = surface.scope;
    scope.addEventListener('input', function (event) {
      var input = event.target.closest('[data-cebe-qty] input');
      var line = input && input.closest('[data-cebe-key]');
      if (line) draft = { scope: scope, key: line.dataset.cebeKey, value: input.value };
    });
    scope.addEventListener('click', function (event) {
      var line = event.target.closest('[data-cebe-key]');
      if (!line) return;
      var remove = event.target.closest('[data-cebe-remove]');
      var step = event.target.closest('[data-cebe-qty-step]');
      if (remove) {
        event.preventDefault(); // the cart page link url_to_remove is the no-JavaScript path
        requestQuantity(surface, line, 0, true);
      } else if (step) {
        var count = parseInt(line.dataset.cebeQuantity, 10) || 0;
        requestQuantity(surface, line, count + parseInt(step.dataset.cebeQtyStep, 10), false);
      }
    });
    scope.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cebe-qty] input');
      var line = input && input.closest('[data-cebe-key]');
      if (!line) return;
      function change() {
        if (!input.isConnected || !scope.contains(input)) return;
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        if (String(quantity) !== line.dataset.cebeQuantity) requestQuantity(surface, line, quantity, true);
      }
      // Replacing an input can synchronously fire a native change before it disconnects.
      if (event.isTrusted) Promise.resolve().then(change);
      else change(); // Enter's synthetic change stays immediate.
    });
    scope.addEventListener('keydown', function (event) {
      var input = event.key === 'Enter' && event.target.closest('[data-cebe-qty] input');
      if (!input || !input.closest('[data-cebe-key]')) return;
      event.preventDefault(); // no form submit on the cart page; the number is sent at once
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  var drawerSurface = {
    scope: null,
    sections: function () {
      return [SECTION];
    },
    render: function (sections, opts) {
      return renderDrawer(sections[SECTION], opts);
    },
    refresh: refreshDrawer,
    error: function (message) {
      showError(cebeShared.drawer && $('[data-cebe-drawer-error]', cebeShared.drawer), message);
      updateFit(); // the error line takes room too
      updateEdges();
    }
  };

  function initDrawer() {
    registerRenderHold();
    cebeShared.drawer = $('[data-cebe-drawer]');
    if (!cebeShared.drawer || typeof cebeShared.drawer.showModal !== 'function') return;
    drawerSurface.scope = cebeShared.drawer;

    var cartLink = $('[data-cebe-cart-open]');
    if (cartLink) {
      cartLink.addEventListener('click', function (event) {
        if (openDrawer(cartLink)) event.preventDefault();
      });
    }

    cebeShared.drawer.addEventListener('click', function (event) {
      if (event.target === cebeShared.drawer) {
        // Only a click on the backdrop, outside the panel, closes.
        var box = cebeShared.drawer.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) {
          closeDrawer();
        }
        return;
      }
      if (event.target.closest('[data-cebe-drawer-close]')) closeDrawer();
    });

    cebeShared.drawer.addEventListener('cancel', function (event) {
      event.preventDefault(); // Esc: close with the same motion
      closeDrawer();
    });

    cebeShared.drawer.addEventListener('transitionend', function (event) {
      if (event.target === cebeShared.drawer && event.propertyName === 'transform' && !event.pseudoElement && cebeShared.drawer.hasAttribute('data-closing')) {
        finishClose();
      }
    });

    cebeShared.drawer.addEventListener('close', function () {
      window.clearTimeout(cebeShared.closeTimer);
      cebeShared.drawer.removeAttribute('data-closing');
      cebeShared.drawer.removeAttribute('data-shown');
      document.documentElement.classList.remove('cebe-drawer-open');
      document.documentElement.style.removeProperty('--cebe-scrollbar-comp');
      drawerSurface.error('');
      cebeShared.cancelCheckout(cebeShared.drawer);
      // No jump: after the phone buy bar, the main "Add to cart" is far above the viewport.
      if (cebeShared.lastTrigger && typeof cebeShared.lastTrigger.focus === 'function' && document.contains(cebeShared.lastTrigger)) cebeShared.lastTrigger.focus({ preventScroll: true });
    });

    // scroll does not bubble; capture still catches it after the body has been replaced.
    cebeShared.drawer.addEventListener(
      'scroll',
      function () {
        if (cebeShared.edgeTicking) return;
        cebeShared.edgeTicking = true;
        window.requestAnimationFrame(function () {
          cebeShared.edgeTicking = false;
          updateEdges();
        });
      },
      { capture: true, passive: true }
    );
    window.addEventListener(
      'resize',
      function () {
        if (!cebeShared.drawer.open) return;
        updateFit();
        updateEdges();
      },
      { passive: true }
    );

    bindLines(drawerSurface);
    updateExpress(currentCount());
  }

  /* ---------- Cart page: same lines and queue as the drawer; without JavaScript the form works as before ---------- */
  function initCartPage() {
    registerRenderHold();
    var root = $('[data-cebe-cart-page]');
    if (!root || !window.fetch) return;
    var id = root.dataset.sectionId;
    $$('[data-cebe-cart-update]', root).forEach(function (button) {
      button.hidden = true;
    });

    function renderPage(html) {
      var fresh = html && $('[data-cebe-cart-page]', parse(html));
      if (!fresh) return false;
      var descriptor = focusDescriptor(root);
      if ($('[data-cebe-part="lines"]', fresh)) swapParts(root, fresh);
      else root.innerHTML = fresh.innerHTML; // empty cart: the whole page content changes
      restoreFocus(root, descriptor);
      return true;
    }

    var surface = {
      scope: root,
      sections: function () {
        return [id, SECTION];
      },
      render: function (sections, opts) {
        return renderPage(sections[id]) && renderDrawer(sections[SECTION], opts); // the drawer keeps the header number right
      },
      refresh: function () {
        var ticket = ++cebeShared.issued;
        return limitedJson(window.location.pathname + '?sections=' + encodeURIComponent(id) + ',' + SECTION, { headers: { Accept: 'application/json' } }, CART_WAIT)
          .then(function (data) {
            return !current(ticket) || surface.render(data, { keepScroll: true });
          })
          .catch(function () {
            return false;
          });
      },
      error: function (message) {
        showError($('[data-cebe-cart-error]', root), message);
      }
    };
    cebeShared.pageSurface = surface;
    bindLines(surface);
  }
  /* ---- end of lines 390–770 ---- */

  cebeShared.cartIdle = cartIdle;
  cebeShared.current = current;
  cebeShared.clearQueue = clearQueue;
  cebeShared.whenIdle = whenIdle;
  cebeShared.exclusive = exclusive;
  cebeShared.drawerSurface = drawerSurface;
  cebeShared.initDrawer = initDrawer;
  cebeShared.initCartPage = initCartPage;
  cebeShared.done = 2;
})();
